import React, { useState,useEffect } from 'react'
import {config} from '../config'
import * as txApi from '../clients/tx-sls-client'

const txdomain = config()['tourneyx-url']

const ShowPinnedTournaments = ({show_pinned_tournaments,user_information}) => {

    const [isShowPinnedTournaments, setPinTourneyLoaded] = useState(false)
    const [setPinnedTournaments, setPinnedTournamentsList] = useState([]);

    var tournament_list = [];

    const unPinSelectedTournament = (tournament_id, user_id) => {
        console.log('Tournament id to be UNPINNED against user id :::', tournament_id,user_id);
    
        txApi.unpinSelectedTournament(tournament_id,user_id)
          .then(unpinned_response => 
          {          
            console.log('unpinned selected tournament response:::',unpinned_response)
            window.location.reload(false)
          
            
    
            //alert('Tournament has been unpinned!');
            //pinned_tournaments_list = pinned_response;
          })
          .catch(error => {
          console.error(`Error loading unpinned tournament response ${error}`)
        
          })
          .finally(() => {})
    
    }

    if(isShowPinnedTournaments === false  && (show_pinned_tournaments.length) && user_information && user_information.user_id !== null) {
      
        console.log('show_pinned_tournaments response found in component:::',show_pinned_tournaments,isShowPinnedTournaments);      
  
        
        


        if ( user_information && user_information.user_id !== null && user_information.emulate_user_id === null ) {
            tournament_list =  show_pinned_tournaments.map((tournament,index) =>{
                if(tournament.redirect_to_old_tourney_leaderboard === '1'){
                    return   <li key={`tournament${index}`}>
                                <span className="pin-tourney pinned nav-pin" onClick={() => unPinSelectedTournament(tournament.id,user_information.user_id )}><i className="essentials-multiply" aria-hidden="true"></i></span> <span className="nav-pin-tourney"> <a href={`${txdomain}/app/tourney-leaderboard/${tournament.slug}`}> {tournament.tournament_title} </a></span>
                            </li>
                }else{
                    return <li key={`tournament${index}`}>
                                <span className="pin-tourney pinned nav-pin" onClick={() => unPinSelectedTournament(tournament.id,user_information.user_id )}><i className="essentials-multiply" aria-hidden="true"></i></span> <span className="nav-pin-tourney"> <a href={`${txdomain}/leaderboard/standings/${tournament.slug}`}> {tournament.tournament_title} </a></span>
                            </li>
                }
            })
    
            setPinnedTournamentsList(tournament_list)
            setPinTourneyLoaded(true)
        }else{

            if( user_information && user_information.emulate_user_id && user_information.emulate_user_id !== null ){
                tournament_list =  show_pinned_tournaments.map((tournament,index) =>{
                    if(tournament.redirect_to_old_tourney_leaderboard === '1'){
                        return   <li key={`tournament${index}`}>
                                    <span className="pin-tourney pinned nav-pin" onClick={() => unPinSelectedTournament(tournament.id,user_information.emulate_user_id )}><i className="essentials-multiply" aria-hidden="true"></i></span> <span className="nav-pin-tourney"> <a href={`${txdomain}/app/tourney-leaderboard/${tournament.slug}`}> {tournament.tournament_title} </a></span>
                                </li>
                    }else{
                        return <li key={`tournament${index}`}>
                                    <span className="pin-tourney pinned nav-pin" onClick={() => unPinSelectedTournament(tournament.id,user_information.emulate_user_id )}><i className="essentials-multiply" aria-hidden="true"></i></span> <span className="nav-pin-tourney"> <a href={`${txdomain}/leaderboard/standings/${tournament.slug}`}> {tournament.tournament_title} </a></span>
                                </li>
                    }
                })
        
                setPinnedTournamentsList(tournament_list)
                setPinTourneyLoaded(true)
            }

        }
        
        
        
    }else{
        
       

    }


    console.log('tournament_list output:::',setPinnedTournaments)

    return (
        <>
            <ul>
                {setPinnedTournaments}
            </ul>
        </>
    )
    

   
}

export default ShowPinnedTournaments